import { Fragment } from 'react';
import styles from './styles.module.css';

export const Params = ({
  list = [],
  className = '',
}: {
  list: Array<{ label: string; value: string }>;
  className?: string;
}) => (
  <dl className={`${styles.params} ${className}`}>
    {list.map(({ label, value }) => (
      <Fragment key={label}>
        <dt>{label}</dt>
        <dd>{value}</dd>
      </Fragment>
    ))}
  </dl>
);
